<template>
    <div>
        <div class="text-tc-blue-1 text-24 mb-2.5">{{lbl.confirm_redeem.headline2}}</div>
        <div class="flex items-center justify-center text-tc-gray-3 text-20">
            <span class="whitespace-nowrap">{{lbl.confirm_redeem.default_text}}</span>
            <span class="mx-1 text-tc-blue-1 mr-1 whitespace-nowrap"> 
                ฿{{ FilterNumberFormat(campaign.maximumPartialPrice) }} + {{FilterNumberFormat(campaign.maximumPartialPoints ?? 0)}} 
            </span>
            <img class="w-3 mr-5px" src="../../../../../assets/icon/icon-tipcoin.png" /> 
            <span class="whitespace-nowrap">{{lbl.confirm_redeem.to_redeem}}</span>
        </div>
        <div class="text-tc-gray-3 text-20">{{lbl.confirm_redeem.this_reward}}</div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'DefaultConfirmRedeem',
    mixins: [LocaleMixin],
    props: {
        campaign: Object
    },
    data: function () {
        return {
            msg: ''
        };
    },
    created: function () {
        var minutes = this.campaign.minutesValidAfterUsed;
        if (minutes) {
            let days = '';
            let hours = '';
            let result = '';
            if (minutes >= 60) {
                hours = Math.floor(minutes / 60);
                if (hours >= 24) {
                    days = Math.floor(hours / 24);
                }
            }

            if (days > 0) {
                result += days + ' ' + this.lbl.date.days + ' ';
            }

            if (hours / 24 > 0) {
                result += (hours % 24) + ' ' + this.lbl.date.hours + ' ';
            }

            if (minutes / 60 > 0) {
                result += (minutes % 60) + ' ' + this.lbl.date.minutes_short;
            }

            this.msg = Util.stringFormat(this.lbl.confirm_redeem.defualt_have_time, result);
        } else {
            this.msg = this.lbl.confirm_redeem.default;
        }
    }
}
</script>
